import React, { useState } from "react";
import { Badge } from "antd";
import { WhatsAppOutlined } from "@ant-design/icons";
import useChatWhatsapp from "../Chat/useChatWhatsapp";
import BurbujaWhatsapp from "./BurbujaWhatsapp";
import ModalNuevaConversacion from "../ModalNuevaConversacion";
import ModalMensajeMasivo from "../ModalMensajeMasivo";
import { WA } from "../../theme";

const BurbujaWhatsappGlobal = ({
  headersToken,
  empresaId,
  permisoElementosWhatsapp,
  permisoGuardarImagenInsumo,
  permisoMensajeMasivo,
  abierto,
  onAbrir,
  onCerrar,
  onAbrirVistaCompleta,
}) => {
  const [modalNueva, setModalNueva] = useState(false);
  const [modalMasivo, setModalMasivo] = useState(false);

  const chat = useChatWhatsapp({ headersToken });

  const esMovil = typeof window !== "undefined" && window.innerWidth <= 1000;
  if (esMovil || chat.conexionActiva !== true) return null;

  return (
    <>
      {!abierto && (
        <div
          onClick={onAbrir}
          style={{
            position: "fixed",
            right: 24,
            bottom: 100,
            zIndex: 1000,
            cursor: "pointer",
          }}
        >
          <Badge
            count={chat.totalNoLeidos}
            overflowCount={99}
            size="small"
            offset={[-8, 8]}
          >
            <div
              style={{
                width: 52,
                height: 52,
                borderRadius: "50%",
                backgroundColor: WA.lima,
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
              }}
            >
              <WhatsAppOutlined style={{ fontSize: 26 }} />
            </div>
          </Badge>
        </div>
      )}

      <BurbujaWhatsapp
        abierto={abierto}
        onCerrar={onCerrar}
        onAbrirVistaCompleta={onAbrirVistaCompleta}
        conexionActiva={chat.conexionActiva}
        conversaciones={chat.conversaciones}
        conversacionActiva={chat.conversacionActiva}
        mensajes={chat.mensajes}
        loadingConversaciones={chat.loadingConversaciones}
        loadingMensajes={chat.loadingMensajes}
        enviando={chat.enviando}
        esMaster={chat.esMaster}
        numeroPorUsuario={chat.numeroPorUsuario}
        miNumero={chat.miNumero}
        miLineaId={chat.miLineaId}
        hayMas={chat.hayMas}
        cargandoMas={chat.cargandoMas}
        seleccionarConversacion={chat.seleccionarConversacion}
        volverALista={chat.volverALista}
        cargarMasMensajes={chat.cargarMasMensajes}
        enviarMensaje={chat.enviarMensaje}
        enviarMediaArchivo={chat.enviarMediaArchivo}
        enviarPlantilla={chat.enviarPlantilla}
        enviarServicio={chat.enviarServicio}
        headersToken={headersToken}
        empresaId={empresaId}
        puedeGuardarPlantilla={permisoElementosWhatsapp}
        puedeGuardarImagenInsumo={permisoGuardarImagenInsumo}
        permisoMensajeMasivo={permisoMensajeMasivo}
        onNuevaConversacion={() => setModalNueva(true)}
        onMensajeMasivo={permisoMensajeMasivo ? () => setModalMasivo(true) : undefined}
        onVincularContacto={chat.vincularContacto}
      />

      <ModalNuevaConversacion
        visible={modalNueva}
        headersToken={headersToken}
        empresaId={empresaId}
        onIniciarYEnviar={(telefono, fd, onExito, contactoId) =>
          chat.iniciarYEnviarPlantilla(
            telefono,
            fd,
            (conv) => {
              chat.seleccionarConversacion(conv);
              onExito?.();
            },
            contactoId,
          )
        }
        onCancel={() => setModalNueva(false)}
      />

      <ModalMensajeMasivo
        visible={modalMasivo}
        headersToken={headersToken}
        empresaId={empresaId}
        onEnviarMasivo={chat.enviarPlantillaMasiva}
        onCancel={() => setModalMasivo(false)}
      />
    </>
  );
};

export default BurbujaWhatsappGlobal;
